import React, { memo, useCallback } from "react";
import { Button, Divider, HStack, Stack, Text } from "@chakra-ui/react";
import { RelatedMessageThreadFragment } from "gql/graphql";
import { FolderForwardIcon } from "modules/icons";
import { useRouter } from "next/router";
import RelatedMessageThread from "modules/messaging/_shared/related-message-thread";
import { useOverlay } from "modules/providers/overlay-provider";
import {
  MESSAGE_ID_QUERY_STRING,
  MESSAGE_THREAD_ID_QUERY_STRING,
} from "modules/hooks/use-query-string";

interface IProps {
  relatedMessageThreads?: ReadonlyArray<RelatedMessageThreadFragment> | null;
}

const RelatedMessageThreadList = ({ relatedMessageThreads }: IProps) => {
  const { pathname, query, push } = useRouter();
  const { closeDrawer } = useOverlay();

  const onMessageThreadClick = useCallback(
    (messageThreadId: string) => () => {
      closeDrawer();
      const newQuery = { ...query };
      delete newQuery[MESSAGE_ID_QUERY_STRING];
      newQuery[MESSAGE_THREAD_ID_QUERY_STRING] = messageThreadId;
      push({
        pathname,
        query: newQuery,
      });
    },
    [closeDrawer, pathname, push, query],
  );

  if (!relatedMessageThreads || relatedMessageThreads.length === 0) {
    return null;
  }

  return (
    <Stack spacing={2}>
      <HStack>
        <FolderForwardIcon boxSize={6} fill="black" />
        <Text fontSize={18} fontWeight={600} fontFamily="Outfit">
          Forwards ({relatedMessageThreads.length})
        </Text>
      </HStack>
      <Stack spacing={0} divider={<Divider />}>
        <Divider borderColor="black" />
        {relatedMessageThreads.map((relatedMessageThread, index) => (
          <Button
            variant="link"
            noOfLines={1}
            key={index}
            onClick={onMessageThreadClick(relatedMessageThread.id)}
            h="40px"
          >
            <RelatedMessageThread relatedMessageThread={relatedMessageThread} />
          </Button>
        ))}
      </Stack>
    </Stack>
  );
};

export default memo(RelatedMessageThreadList);
